(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ksc-etsy-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ksc-etsy-reviews')){
customElements.define('ksc-etsy-reviews',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  this.track=this.querySelector('.ksc-track');if(!this.track)return;
  this.cards=[...this.track.children];this.prev=this.querySelector('.ksc-prev');this.next=this.querySelector('.ksc-next');this.status=this.querySelector('.ksc-status');
  this.prev.addEventListener('click',()=>this.move(-1),opts);this.next.addEventListener('click',()=>this.move(1),opts);
  this.track.addEventListener('scroll',()=>this.update(),{...opts,passive:true});
  this.track.addEventListener('keydown',e=>{if(e.target!==this.track)return;if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();if(e.key==='Home'||e.key==='End')this.track.scrollTo({left:e.key==='Home'?0:this.track.scrollWidth,behavior:this.behavior()});else this.move(e.key==='ArrowLeft'?-1:1)}},opts);
  this.querySelectorAll('img').forEach(img=>img.addEventListener('error',()=>{if(img.closest('.ksc-avatar'))img.remove();else img.closest('.ksc-photo-button')?.setAttribute('hidden','')},opts));
  this.dialog=this.querySelector('dialog');
  this.querySelectorAll('.ksc-photo-button').forEach(b=>b.addEventListener('click',()=>{const img=b.querySelector('img');const large=this.dialog.querySelector('img');large.src=img.src;large.alt=img.alt;this.dialog.showModal()},opts));
  this.querySelector('.ksc-close').addEventListener('click',()=>this.dialog.close(),opts);
  this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close()}},opts);
  this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('.ksc-card');if(card)this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'auto'})},opts);
  this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
 }
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect()}
 behavior(){return matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}
 move(dir){const gap=parseFloat(getComputedStyle(this.track).gap)||0;const step=this.cards[0]?.getBoundingClientRect().width+gap;if(step)this.track.scrollBy({left:dir*step,behavior:this.behavior()})}
 update(){const max=this.track.scrollWidth-this.track.clientWidth;this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=max-2;this.prev.hidden=this.next.hidden=max<=2;const r=this.track.getBoundingClientRect();const visible=this.cards.map((c,i)=>({i,r:c.getBoundingClientRect()})).filter(x=>x.r.left<r.right-8&&x.r.right>r.left+8);if(visible.length)this.status.textContent=`${visible[0].i+1}–${visible.at(-1).i+1} / ${this.cards.length}`}
});}


  } catch(e) { console.error(e); }
})();
})();
